import { Grid, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { AggregateIssuesViewStore } from '../../Stores/AggregateIssuesViewStore'
import { IssuesTypeSummaryCard, IssueTypeSummary } from './IssueTypeSummaryCard'

export type IssueTypeCategory = {
  key: 'missingData' | 'customs' | 'shortlandedAndOverlanded' | 'yardIssues'
  issueTypes: IssueTypeSummary[]
}

type Props = {
  viewStore: AggregateIssuesViewStore
  issueTypeCategory: IssueTypeCategory
}

export const IssueTypeSummaryCategory = observer(({ viewStore, issueTypeCategory }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack gap={theme.customSpacing.s}>
      <Typography variant='h4'>{t(issueTypeCategory.key)}</Typography>
      <Grid container spacing={theme.customSpacing.s}>
        {issueTypeCategory.issueTypes
          .filter(i => i.count > 0)
          .map((issueType, index) => (
            <Grid
              key={`issueType-${index}-${issueType.key}`}
              size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
            >
              <IssuesTypeSummaryCard viewStore={viewStore} issueTypeSummary={issueType} />
            </Grid>
          ))}
      </Grid>
    </Stack>
  )
})
